import Icon from 'veui/components/Icon'

Icon.register({
  chat: {
    paths: [
      {
        d: 'M424 384a40 40 0 11-40-40 40 40 0 0140 40zm-176-40a40 40 0 1040 40 40 40 0 00-40-40zm272 0a40 40 0 1040 40 40 40 0 00-40-40zm1 364.33a352 352 0 10-439.46-144.2l-17.1 102.61a32 32 0 0036.82 36.82l102.61-17.1A352.61 352.61 0 00521 708.33zm-315.78-87l-70.31 11.72 11.72-70.31a32 32 0 00-4.63-22.62A287.94 287.94 0 11227.88 626a32.13 32.13 0 00-22.64-4.69z'
      }
    ],
    width: '768',
    height: '768'
  }
})
